import KeenSlider, { KeenSliderInstance } from "keen-slider";

class ManufacturerCards {
    private static readonly cardsWrapperSelector = ".keen-slider";
    private static readonly cardSelector = ".keen-slider__slide";
    private static readonly carouselBlurSelector = ".manufacturer-cards__carousel-blur";
    private static readonly carouselButtonSelector = ".manufacturer-cards__carousel-button";
    private static readonly carouselBlurActiveArea = ".carousel-blur__active-area";

    private root: JQuery;
    private cardsWrapper: JQuery;
    private blurPrev: JQuery;
    private blurNext: JQuery;
    private blurPrevActiveArea: JQuery;
    private blurNextActiveArea: JQuery;
    private buttonPrev: JQuery;
    private buttonNext: JQuery;

    private cardsCount: number;
    private slider: KeenSliderInstance;

    constructor(root: HTMLElement) {
        this.root = $(root);
        this.cardsWrapper = this.root.find(ManufacturerCards.cardsWrapperSelector);
        this.blurPrev = this.root.find(ManufacturerCards.carouselBlurSelector).filter(".left");
        this.blurNext = this.root.find(ManufacturerCards.carouselBlurSelector).filter(".right");
        this.buttonPrev = this.blurPrev.find(ManufacturerCards.carouselButtonSelector);
        this.buttonNext = this.blurNext.find(ManufacturerCards.carouselButtonSelector);
        this.blurPrevActiveArea = this.blurPrev.find(ManufacturerCards.carouselBlurActiveArea);
        this.blurNextActiveArea = this.blurNext.find(ManufacturerCards.carouselBlurActiveArea);

        this.cardsCount = this.cardsWrapper.find(ManufacturerCards.cardSelector).length;

        if (this.cardsCount > 1) {
            this.initSlider();
        }
    }

    private initSlider() {
        this.slider = new KeenSlider(this.root.find(ManufacturerCards.cardsWrapperSelector)[0], {
            slides: {
                perView: 2.32,
            },
            breakpoints: {
                "(min-width: 366px)": {
                    slides: {
                        perView: 3,
                    },
                },
                "(min-width: 541px)": {
                    slides: {
                        perView: 3.27,
                    },
                },
                "(min-width: 768px)": {
                    slides: {
                        perView: 4,
                    },
                },
                "(min-width: 897px)": {
                    slides: {
                        perView: 5.86,
                    },
                },
                "(min-width: 1221px)": {
                    slides: {
                        perView: 6.836,
                    },
                },
                "(min-width: 1367px)": {
                    slides: {
                        perView: 7.47,
                    },
                },
                "(min-width:1631px)": {
                    slides: {
                        perView: 10,
                    },
                },
            },
            selector: ManufacturerCards.cardSelector,
            slideChanged: (instance) => {
                this.updateSliderClasses(instance);
            },
            dragEnded: () => {
                //fix product card stays focused
                (document.activeElement as HTMLElement).blur();
            },
        });

        this.buttonPrev.on("click", () => {
            this.slider.prev();
        });
        this.blurPrevActiveArea.on("click", () => {
            this.slider.prev();
        });
        this.buttonNext.on("click", () => {
            this.slider.next();
        });
        this.blurNextActiveArea.on("click", () => {
            this.slider.next();
        });
    }

    protected updateSliderClasses(instance: KeenSliderInstance) {
        const { abs, maxIdx } = instance.track.details;
        if (abs === 0) {
            this.buttonPrev.addClass("disabled");
            this.blurPrev.addClass("d-none");
        } else {
            this.buttonPrev.removeClass("disabled");
            this.blurPrev.removeClass("d-none");
        }

        if (abs >= maxIdx) {
            this.buttonNext.addClass("disabled");
            this.blurNext.addClass("d-none");
        } else {
            this.buttonNext.removeClass("disabled");
            this.blurNext.removeClass("d-none");
        }
    }
}

$(() => {
    $(".manufacturer-cards").each((_, root) => {
        new ManufacturerCards(root);
    });
});
